import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';
import { ProjectStatusesEnum, PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ROUTES } from 'src/components/app/app-routes.constants';
import { IProject } from 'src/pages/projects/projects.interfaces';
import { PROJECT_MODALS } from 'src/pages/projects/projects.constants';
import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

const ProjectsTableAction = ({
  record,
  handleModals,
}: {
  record: IProject;
  handleModals: (modal: string, record: IProject) => void;
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation('projects');

  const { canEdit } = useUserCanManageDocument({
    createdBy: record.createdBy,
    platformPermission: PLATFORM_PERMISSIONS.projectManagement,
  });

  const popoverElements: any[] = [
    {
      label: t('labels.viewDetails'),
      icon: ICONS.foodMenu,
      key: ICONS.foodMenu,
      handler: () => navigate(`${ROUTES.project}/${record._id}`),
    },
  ];

  if (canEdit) {
    if (record.status === ProjectStatusesEnum.ARCHIVED) {
      popoverElements.push({
        label: 'Unarchive project',
        icon: ICONS.archiveOut,
        color: PLATFORM_THEME_COLORS.tone.red,
        key: ICONS.archiveOut,
        handler: () => handleModals(PROJECT_MODALS.unarchiveProject, record),
      });
    } else {
      if (record.status !== ProjectStatusesEnum.FINISHED) {
        popoverElements.push({
          label: t('labels.finishProject'),
          icon: ICONS.calendarCheck,
          key: ICONS.calendarCheck,
          handler: () => handleModals(PROJECT_MODALS.finishProject, record),
        });
      }

      if (record.status === ProjectStatusesEnum.FINISHED) {
        popoverElements.push({
          label: t('labels.activateProject'),
          icon: ICONS.revision,
          key: ICONS.revision,
          handler: () => handleModals(PROJECT_MODALS.activateProject, record),
        });
      }

      if (record.status !== ProjectStatusesEnum.DELETED) {
        popoverElements.push({
          label: t('labels.deleteProject'),
          icon: ICONS.trash,
          key: ICONS.trash,
          color: PLATFORM_THEME_COLORS.tone.red,
          handler: () => handleModals(PROJECT_MODALS.deleteProject, record),
        });
      }

      popoverElements.push({
        label: t('labels.archiveProject'),
        icon: ICONS.archiveIn,
        color: PLATFORM_THEME_COLORS.tone.red,
        key: ICONS.archiveIn,
        handler: () => handleModals(PROJECT_MODALS.archiveProject, record),
      });
    }
  }

  return (
    <Popover trigger="hover" elements={popoverElements}>
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default ProjectsTableAction;
